<div class="active-layer-map-wrapper">
  <div id="ol-active-layer-map" class="ol-map"></div>
  <div #olPopup class="ol-popup"></div>
</div>
